import {
	WeaTools
} from 'ecCom'

export const getHasRight = (params) => {
	return WeaTools.callApi('/api/hrm/sysadmin/hasRight', 'GET', params);
}

export const getHeaderColumn = (params) => {
	return WeaTools.callApi('/api/hrm/sysadmin/getResourceItem', 'GET', params);
}

export const getTableInfo = (params) => {
	return WeaTools.callApi('/api/hrm/sysadmin/getPagingResult', 'POST', params);
}

export const getSearchCondition = () => {
	return WeaTools.callApi('/api/hrm/sysadmin/getSearchCondition', 'GET');
}

export const getSecSettingCondition = (params) => {
	return WeaTools.callApi('/api/hrm/sysadmin/getHrmSystemSecuritySetting', 'GET', params);
}

export const secSettingSave = (params) => {
	return WeaTools.callApi('/api/hrm/sysadmin/save', 'POST', params);
}

export const isUseSecondaryPwd = (params) => {
	return WeaTools.callApi('/api/hrm/secondarypwd/isUseSecondaryPwd', 'GET', params);
}

export const saveUseSecondaryPwd = (params) => {
	return WeaTools.callApi('/api/hrm/secondarypwd/saveUseSecondaryPwd', 'POST', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/systemCard.js